import { PayloadAction } from '@reduxjs/toolkit';
import { FIELD__base } from '@shared/dto/generation/graph_invoke/_fields/_base/FIELD__base';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

interface Payload {
  column: FIELD__base;
  row: FIELD__base;
  g_hovered_grid2d_dimension_from_grid: boolean;
}

export const LOCAL__ui_generation_grid2d_set_hovered_dimensions = (value: Payload): PayloadAction<Payload> => ({
  type: ENUM__redux_action.UI_GENERATION_GRID2D_SET_HOVERED_DIMENSIONS,
  payload: value,
});

export function INIT_LOCAL__ui_generation_grid2d_set_hovered_dimensions(state: STATE__ui, action: PayloadAction<Payload>) {
  let { column, row, g_hovered_grid2d_dimension_from_grid } = action.payload;

  if (!state.g_hovered_grid2d_column.is_equal(column)) {
    state.g_hovered_grid2d_column = column.clone();
  }

  if (!state.g_hovered_grid2d_row.is_equal(row)) {
    state.g_hovered_grid2d_row = row.clone();
  }

  state.g_hovered_grid2d_dimension_from_grid = g_hovered_grid2d_dimension_from_grid;
}
